import type { AccountType } from '@/types/db'

// Emoji padrão por tipo de conta — usado quando a conta não tem ícone próprio,
// para que TODA conta apareça com um ícone (mesmo as antigas, sem migração).
const DEFAULT: Record<AccountType, string> = {
  corrente: '🏦',
  poupanca: '🐷',
  cash: '💵',
  carteira: '👛',
  investimento: '📈',
  cartao: '💳',
}

// Ícone da conta: o emoji escolhido pelo usuário (coluna `icon`) ou o padrão do tipo.
export function accountIcon(account: { icon?: string | null; type: AccountType }): string {
  return account.icon?.trim() || DEFAULT[account.type]
}

// Emoji padrão de um tipo (para placeholder do formulário).
export function defaultAccountIcon(type: AccountType): string {
  return DEFAULT[type]
}
